<template>
  <div class="page-container">
    <el-card style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input 
            v-model="searchKeyword" 
            placeholder="搜索标题或内容" 
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="platformFilter" placeholder="筛选平台" clearable @change="handleSearch" style="width: 100%;">
            <el-option label="全部平台" :value="null"></el-option>
            <el-option label="微信公众号" value="wechat"></el-option>
            <el-option label="抖音" value="douyin"></el-option>
            <el-option label="小红书" value="xiaohongshu"></el-option>
            <el-option label="知乎" value="zhihu"></el-option>
            <el-option label="头条" value="toutiao"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="statusFilter" placeholder="筛选状态" clearable @change="handleSearch" style="width: 100%;">
            <el-option label="全部状态" :value="null"></el-option>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="已发布" :value="1"></el-option>
            <el-option label="已撤回" :value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-button 
            type="primary" 
            @click="handleAdd" 
            icon="el-icon-plus">
            新增内容
          </el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <el-table 
        :data="tableData" 
        border 
        v-loading="loading"
        style="width: 100%">
        <el-table-column prop="title" label="标题" width="200"></el-table-column>
        <el-table-column label="平台" width="120">
          <template slot-scope="scope">
            <el-tag :type="getPlatformType(scope.row.platform)">
              {{ getPlatformName(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="info">草稿</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success">已发布</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="warning">已撤回</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="300">
          <template slot-scope="scope">
            <div class="content-preview">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.publishTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="标题" required>
          <el-input v-model="form.title" placeholder="请输入内容标题"></el-input>
        </el-form-item>
        <el-form-item label="平台" required>
          <el-select v-model="form.platform" placeholder="请选择发布平台">
            <el-option label="微信公众号" value="wechat"></el-option>
            <el-option label="抖音" value="douyin"></el-option>
            <el-option label="小红书" value="xiaohongshu"></el-option>
            <el-option label="知乎" value="zhihu"></el-option>
            <el-option label="头条" value="toutiao"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" required>
          <el-input 
            v-model="form.content" 
            type="textarea" 
            :rows="8"
            placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="封面图片">
          <el-upload
            class="cover-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleCoverSuccess"
            :before-upload="beforeCoverUpload">
            <img v-if="form.coverImage" :src="form.coverImage" class="cover-image">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">草稿</el-radio>
            <el-radio :label="1">已发布</el-radio>
            <el-radio :label="2">已撤回</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MediaManage',
  data() {
    return {
      searchKeyword: '',
      platformFilter: null,
      statusFilter: null,
      loading: false,
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        title: '',
        platform: '',
        content: '',
        coverImage: '',
        status: 0
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/admin/upload/image',
      uploadHeaders: {
        'Authorization': 'Bearer ' + localStorage.getItem('admin_token')
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          pageNum: this.page.current,
          pageSize: this.page.size,
          keyword: this.searchKeyword,
          platform: this.platformFilter,
          status: this.statusFilter
        }
        const res = await this.$axios.get('/admin/media/list', { params })
        if (res.data.code === 200) {
          this.tableData = res.data.data.records || []
          this.page.total = res.data.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.loadData()
    },
    handleReset() {
      this.searchKeyword = ''
      this.platformFilter = null
      this.statusFilter = null
      this.page.current = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.page.current = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.page.size = size
      this.page.current = 1
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增自媒体内容'
      this.form = {
        id: null,
        title: '',
        platform: '',
        content: '',
        coverImage: '',
        status: 0
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑自媒体内容'
      this.form = { ...row }
      this.dialogVisible = true
    },
    async handleSubmit() {
      if (!this.form.title) {
        this.$message.warning('请输入标题')
        return
      }
      if (!this.form.platform) {
        this.$message.warning('请选择平台')
        return
      }
      if (!this.form.content) {
        this.$message.warning('请输入内容')
        return
      }

      try {
        const url = this.form.id ? '/admin/media/update' : '/admin/media/add'
        const res = await this.$axios.post(url, this.form)
        if (res.data.code === 200) {
          this.$message.success(this.form.id ? '更新成功' : '添加成功')
          this.dialogVisible = false
          this.loadData()
        }
      } catch (error) {
        this.$message.error('操作失败')
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除该内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.delete(`/admin/media/delete/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    getPlatformName(platform) {
      const map = {
        'wechat': '微信公众号',
        'douyin': '抖音',
        'xiaohongshu': '小红书',
        'zhihu': '知乎',
        'toutiao': '头条'
      }
      return map[platform] || platform
    },
    getPlatformType(platform) {
      const map = {
        'wechat': 'success',
        'douyin': 'warning',
        'xiaohongshu': 'danger',
        'zhihu': 'info',
        'toutiao': 'primary'
      }
      return map[platform] || ''
    },
    handleCoverSuccess(res, file) {
      if (res.code === 200) {
        this.form.coverImage = res.data.url
      }
    },
    beforeCoverUpload(file) {
      const isImage = file.type.indexOf('image') !== -1
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImage && isLt5M
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}

.content-preview {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cover-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cover-uploader:hover {
  border-color: #409EFF;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.cover-image {
  width: 148px;
  height: 148px;
  display: block;
  object-fit: cover;
}
</style>
